// @flow

import {
  getFormSettings,
  getLabels,
  hasShops,
} from './main';

import {
  getErrorMessages,
  getRequired,
  getEmail,
  getEmailEqual,
  getNoSelection,
  getPhone,
  getDate,
  getNotSend,
} from './errorMessages';

export {
  getDate,
  getEmail,
  getEmailEqual,
  getErrorMessages,
  getFormSettings,
  getNoSelection,
  getNotSend,
  getPhone,
  getRequired,
  getLabels,
  hasShops,
};

export default null;
